// Dates and times are always shown in English, whatever language the browser is set to
export const DATE_LOCALE = 'en-GB';
